import React, { useState, useCallback } from "react";
import { injectIntl } from "react-intl";
import DataGrid from "components/data-grid";
import { withRouter } from "react-router-dom";
import ValidatedForm, { isPasswordComplexityError } from "components/form";
import FormConfirm from "components/form/form-confirm";
import {
  defaultValues,
  validationSchema,
  ChangePasswordForm,
} from "../forms/change-password-form";
import {checkUserPassService, updateUserService} from "../../../services/userServices";

const getUpdateErrorMessageId = error => {
  const data = error?.response?.data;
  const status = error?.response?.status;
  const message = typeof data === "string" ? data : data?.[status] || data?.message;

  return isPasswordComplexityError(message) ? "errors.user.passwordNotComplex" : "app.user.password.error";
};

const ChangePasswordSection = ({ user, intl }) => {
  const [success, setSuccess] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateErrorMessageId, setUpdateErrorMessageId] = useState("app.user.password.error");

  const handleCloseConfirm = useCallback(() => {
      setShowCheck(false)
      setShowUpdate(false)
  }, []);

  const updateCallback = () => {
      setSuccess(true);
      setShowUpdate(true);

      setTimeout(() => {
          setShowUpdate(false)
      }, 5000)
  }

  const updateErrorCallback = (error) => {
      setSuccess(false)
      setUpdateErrorMessageId(getUpdateErrorMessageId(error))
      setShowUpdate(true)

      setTimeout(() => {
          setShowUpdate(false)
      }, 5000)
  }

  const handleChangePassword = (values) => {
      const credentials = {
          username: user.username,
          password: values.oldPassword
      }

      checkUserPassService(credentials).then((response) => {
          if (showCheck) setShowCheck(false)
          if (response.data.credentials.username === user.username) {
              const body = {
                  credentials: {
                      username: user.username,
                      password: values.newPassword
                  }
              }

              updateUserService(user.username, body, updateCallback, updateErrorCallback)
          }
      }).catch(() => {
          setSuccess(false)
          setShowCheck(true)

          setTimeout(() => {
              setShowCheck(false)
          }, 5000)
      })
  };

  return (
    <>
      <div>
        <FormConfirm
          show={showCheck || showUpdate}
          error={!success}
          onClose={handleCloseConfirm}
          label={
              showCheck ?
                  intl.formatMessage({ id: "app.form.wrongPassword" }) :
                  showUpdate ?
                    success ?
                      intl.formatMessage({ id: "app.form.passwordChange.successful" }) :
                      intl.formatMessage({ id: updateErrorMessageId }) : ""
          }
        />
      </div>
      <ValidatedForm
        cancellable={false}
        initialValues={defaultValues}
        validationSchema={validationSchema(intl)}
        onSubmit={handleChangePassword}
      >
        {props => (
          <DataGrid>
            <ChangePasswordForm {...props} />
          </DataGrid>
        )}
      </ValidatedForm>
    </>
  );
};

export default withRouter(injectIntl(ChangePasswordSection));
